const useSocialMediaLinks = () => {
    const socialMediaLinks = [
        {
            name: 'WhatsApp',
            url: 'https://wa.me/+79235089524',
            icon: <WhatsAppIcon />,
        },
        // {
        //     name: 'Telegram',
        //     url: 'https://t.me/rostenglish',
        //     icon: <TelegramIcon />,
        // },
        {
            name: 'VK',
            url: 'https://vk.com/rostenglish',
            icon: <VKIcon />,
        },
        // {
        //     name: 'Skype',
        //     url: 'julie-anyday',
        //     icon: <SkypeIcon />,
        // },
    ];
    return socialMediaLinks;
};

// Icon components for better reusability
const WhatsAppIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" aria-label="WhatsApp" role="img" viewBox="0 0 512 512" fill="none">
        <rect width="512" height="512" rx="15%" fill="#25d366"></rect>
        <path fill="#25d366" stroke="#ffffff" strokeWidth="26" d="M123 393l14-65a138 138 0 1150 47z"></path>
        <path fill="#ffffff" d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"></path>
    </svg>
);
// const TelegramIcon = () => (
//     <svg xmlns="http://www.w3.org/2000/svg" aria-label="Telegram" role="img" viewBox="0 0 512 512" fill="none">
//         <rect width="512" height="512" rx="15%" fill="#37aee2"></rect>
//         <path fill="#c8daea" d="M199 404c-11 0-10-4-13-14l-32-105 245-144"></path>
//         <path fill="#a9c9dd" d="M199 404c7 0 11-4 16-8l45-43-56-34"></path>
//         <path fill="#f6fbfe" d="M204 319l135 99c14 9 26 4 30-14l55-258c5-22-9-32-24-25L79 245c-21 8-21 21-4 26l83 26 190-121c9-5 17-3 11 4"></path>
//     </svg>
// );
const VKIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" aria-label="VK" role="img" viewBox="0 0 512 512" fill="none">
        <rect width="512" height="512" rx="15%" fill="#5281b8"></rect>
        <path fill="#ffffff" d="M274 363c5-1 14-3 14-15 0 0-1-30 13-34s32 29 51 42c14 9 25 8 25 8l51-1s26-2 14-23c-1-2-9-15-39-42-31-30-26-25 11-76 23-31 33-50 30-57-4-7-20-6-20-6h-57c-6 0-9 1-12 6 0 0-9 25-21 45-25 43-35 45-40 42-9-5-7-24-7-37 0-45 7-61-13-65-13-2-59-4-73 3-7 4-11 11-8 12 3 0 12 1 17 7 8 13 9 75-2 81-15 11-53-62-62-86-2-6-5-7-12-9H79c-6 0-15 1-11 13 27 56 83 193 184 192z"></path>
    </svg>
);
// const SkypeIcon = () => (
//     <svg fill="#00AEF3" xmlns="http://www.w3.org/2000/svg" width="256px" height="256px" viewBox="0 0 512 512" stroke="#00AEF3">
//         <g>
//             <path d="M493.43,310.244c3.631-16.618,5.563-33.859,5.563-51.562c0-132.728-107.588-240.317-240.316-240.317c-14.009,0-27.732,1.222-41.094,3.518C196.099,8.359,170.686,0.5,143.427,0.5C66.465,0.5,4.075,62.903,4.075,139.865c0,25.725,6.999,49.803,19.163,70.487c-3.194,15.607-4.878,31.775-4.878,48.331c0,132.728,107.589,240.316,240.316,240.316c15.047,0,29.742-1.396,44.014-4.042c19.613,10.555,42.043,16.543,65.871,16.543c76.975,0,139.365-62.391,139.365-139.365C507.926,349.903,502.699,328.895,493.43,310.244z M381.922,373.52c-11.104,15.745-27.533,28.208-48.816,37.053c-21.072,8.758-46.334,13.199-75.091,13.199c-34.52,0-63.463-6.063-86.043-18.039c-16.144-8.733-29.467-20.535-39.573-35.119c-10.205-14.733-15.382-29.33-15.382-43.428c0-8.808,3.381-16.442,10.03-22.681c6.587-6.2,15.021-9.331,25.076-9.331c8.259,0,15.382,2.47,21.171,7.36c5.527,4.69,10.28,11.627,14.085,20.585c4.267,9.756,8.908,17.989,13.811,24.477c4.716,6.238,11.49,11.478,20.148,15.582c8.721,4.13,20.46,6.213,34.907,6.213c19.874,0,36.167-4.242,48.418-12.613c11.963-8.158,17.775-17.965,17.775-29.979c0-9.494-3.043-16.941-9.281-22.793c-6.549-6.113-15.156-10.879-25.649-14.147c-10.915-3.393-25.749-7.073-44.076-10.916c-24.938-5.339-46.135-11.677-62.989-18.851c-17.229-7.323-31.126-17.49-41.282-30.216c-10.317-12.899-15.544-29.105-15.544-48.156c0-18.152,5.489-34.52,16.318-48.63c10.741-14.022,26.436-24.914,46.646-32.386c19.948-7.373,43.665-11.116,70.5-11.116c21.469,0,40.332,2.482,56.09,7.385c15.83,4.928,29.193,11.59,39.684,19.786c10.568,8.259,18.428,17.092,23.367,26.261c4.99,9.282,7.512,18.489,7.512,27.421c0,8.583-3.307,16.393-9.855,23.18c-6.588,6.849-14.885,10.33-24.678,10.33c-8.896,0-15.869-2.183-20.697-6.462c-4.504-3.967-9.17-10.18-14.348-19.087c-6-11.39-13.248-20.36-21.569-26.685c-8.072-6.151-21.571-9.27-40.122-9.27c-17.229,0-31.226,3.468-41.631,10.28c-10.03,6.575-14.896,14.123-14.896,23.042c0,5.477,1.56,10.043,4.791,13.985c3.418,4.167,8.234,7.834,14.322,10.878c6.313,3.181,12.825,5.701,19.337,7.498c6.687,1.859,17.902,4.603,33.259,8.159c19.45,4.167,37.327,8.846,53.134,13.898c15.994,5.127,29.828,11.439,41.096,18.775c11.514,7.498,20.635,17.116,27.096,28.619c6.488,11.527,9.768,25.774,9.768,42.317C398.738,339.687,393.088,357.738,381.922,373.52z"/>
//         </g>
//     </svg>
// )

export default function Socials({className}) {
    const socialMediaLinks = useSocialMediaLinks();
    return (
        <div className={`${className} socials-media`}>
            <ul className="socials-media__list">
                {socialMediaLinks.map((link, index) => (
                    <li key={index} className="social-media__item">
                        <SocialMediaLink
                            name={link.name}
                            url={link.url}
                            icon={link.icon}
                        />
                    </li>
                ))}
            </ul>
        </div>
    )
}

const SocialMediaLink = ({ name, url, icon }) => {
    const socialMediaLinkStyleImage = {
        display: 'block',
        width: '2rem',
        height: '2rem',
    }
    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            <span style={socialMediaLinkStyleImage}>
                {icon}
            </span>
            <p>{name}</p>
        </a>
    );
};
